import { render, staticRenderFns } from "./go_to_top.vue?vue&type=template&id=5585a5a5&scoped=true"
import script from "./go_to_top.vue?vue&type=script&lang=js"
export * from "./go_to_top.vue?vue&type=script&lang=js"
import style0 from "./go_to_top.vue?vue&type=style&index=0&id=5585a5a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5585a5a5",
  null
  
)

export default component.exports